import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaBriefcase, FaHeartbeat, FaChartLine, FaUsers } from 'react-icons/fa';

const jobListings = [
  {
    id: '1',
    title: 'Loan Officer',
    department: 'Finance',
    location: 'Nairobi, Kenya',
    description: 'Drive financial empowerment by assisting clients with tailored loan solutions.',
    details: {
      employmentType: 'Full-Time',
      experienceLevel: 'Mid-Level',
    },
    fullDescription:
      'As a Loan Officer at TGL Credit Limited, you will play a pivotal role in helping clients achieve their financial goals by providing tailored loan solutions, including Logbook Loans, Asset Financing, and LPO Financing. You will assess client applications, conduct credit evaluations, and offer personalized financial advice to ensure client success. This role requires strong interpersonal skills and a passion for empowering clients through innovative financial products.',
    skillsNeeded: [
      'Required: Bachelor’s degree in Finance, Business, or related field',
      'Required: 2+ years of experience in financial services or lending',
      'Required: Strong analytical and communication skills',
      'Preferred: Knowledge of Kenyan financial regulations',
      'Preferred: Proficiency in CRM software',
    ],
    howToApply: 'Submit your application via the form below.',
  },
  {
    id: '3',
    title: 'Financial Analyst',
    department: 'Finance',
    location: 'Nairobi, Kenya',
    description: 'Analyze market trends to support strategic financial decisions.',
    details: {
      employmentType: 'Full-Time',
      experienceLevel: 'Senior-Level',
    },
    fullDescription:
      'As a Financial Analyst at TGL Credit Limited, you will drive strategic decision-making by analyzing market trends, financial data, and economic indicators. Your insights will guide our loan product development and risk management strategies. This role requires a deep understanding of financial modeling and the ability to translate complex data into actionable recommendations for senior management.',
    skillsNeeded: [
      'Required: Bachelor’s degree in Finance, Economics, or related field',
      'Required: 5+ years of experience in financial analysis or banking',
      'Required: Advanced proficiency in Excel and financial modeling tools',
      'Preferred: CFA or CPA certification',
      'Preferred: Experience with data visualization tools (e.g., Tableau)',
    ],
    howToApply: 'Submit your application via the form below.',
  },
];

const IconArrow = ({ className }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
  </svg>
);

const TabIcon = ({ tab, isActive }) => {
  const color = isActive ? 'text-white' : 'text-primary-blue';
  switch (tab) {
    case 'All':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 4h4v4H4V4zm6 0h4v4h-4V4zm6 0h4v4h-4V4zM4 10h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4zM4 16h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4z" />
        </svg>
      );
    case 'Finance':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92c-.5.51-.86.97-1.04 1.69-.08.32-.13.68-.13 1.14h-2v-.5c0-.83.36-1.57 1.06-2.09l1.1-1.12c.31-.31.54-.74.54-1.24 0-.95-.77-1.75-1.73-1.75-.96 0-1.73.8-1.73 1.75H9c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .82-.29 1.58-.83 2.2z" />
        </svg>
      );
    case 'Customer Service':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.72 10.78c-.81-2.67-3.15-4.78-6.22-4.78s-5.41 2.11-6.22 4.78c-.13.43.1.89.53 1.02.43.13.89-.1 1.02-.53.62-2.03 2.36-3.27 4.67-3.27s4.05 1.24 4.67 3.27c.13.43.59.66 1.02.53.43-.13.66-.59.53-1.02zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
        </svg>
      );
    case 'Operations':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.30-.61-.22l-2.49 1c-.52-.40-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.30.61.22l2.49-1c.52.40 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
        </svg>
      );
    case 'Technology':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm6 13h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z" />
        </svg>
      );
    default:
      return null;
  }
};

function Career() {
  const [filter, setFilter] = useState('All');
  const [isReadMoreModalOpen, setIsReadMoreModalOpen] = useState(false);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    position: '',
    coverLetter: null,
    cv: null,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const applyModalRef = useRef(null);

  const maxFileSize = 5 * 1024 * 1024; // 5MB

  const filteredJobs = filter === 'All' ? jobListings : jobListings.filter((job) => job.department === filter);

  const openReadMoreModal = (job) => {
    setSelectedJob(job);
    setIsReadMoreModalOpen(true);
  };

  const closeReadMoreModal = () => {
    setIsReadMoreModalOpen(false);
    setSelectedJob({});
  };

  const openApplyModal = (jobTitle = '') => {
    setFormData({ fullName: '', email: '', position: jobTitle, coverLetter: null, cv: null });
    setIsApplyModalOpen(true);
    setFormErrors({});
    setSubmissionError('');
    setShowSuccessMessage(false);
  };

  const closeApplyModal = () => {
    setIsApplyModalOpen(false);
    setFormData({ fullName: '', email: '', position: '', coverLetter: null, cv: null });
    setFormErrors({});
    setSubmissionError('');
    setShowSuccessMessage(false);
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    if (formErrors[name]) {
      setFormErrors({ ...formErrors, [name]: '' });
    }
    if (submissionError) {
      setSubmissionError('');
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.fullName.trim() || formData.fullName.length < 2) {
      errors.fullName = 'Full name must be at least 2 characters';
    }
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'A valid email address is required';
    }
    if (!formData.position.trim()) {
      errors.position = 'Position is required';
    }
    if (!formData.coverLetter) {
      errors.coverLetter = 'Cover letter is required';
    } else if (formData.coverLetter.type !== 'application/pdf') {
      errors.coverLetter = 'Cover letter must be a PDF file';
    } else if (formData.coverLetter.size > maxFileSize) {
      errors.coverLetter = 'Cover letter file size exceeds 5MB';
    }
    if (!formData.cv) {
      errors.cv = 'CV is required';
    } else if (formData.cv.type !== 'application/pdf') {
      errors.cv = 'CV must be a PDF file';
    } else if (formData.cv.size > maxFileSize) {
      errors.cv = 'CV file size exceeds 5MB';
    }
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setIsSubmitting(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('fullName', formData.fullName);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('position', formData.position);
      formDataToSend.append('coverLetter', formData.coverLetter);
      formDataToSend.append('cv', formData.cv);

      console.log('Submitting career form:', {
        fullName: formData.fullName,
        email: formData.email,
        position: formData.position,
        coverLetter: formData.coverLetter?.name,
        cv: formData.cv?.name,
      });

      const response = await axios.post(
        process.env.REACT_APP_CAREER_API_URL || 'https://tglcredit.co.ke/api/career-email.php',
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      console.log('Application sent successfully:', response.data);
      setShowSuccessMessage(true);
      setFormErrors({});
      setTimeout(() => {
        closeApplyModal();
      }, 3000);
    } catch (error) {
      console.error('Error sending application:', error);
      let errorMessage = 'Failed to send application. Please try again.';
      if (error.response?.data?.message) {
        errorMessage = `Failed to send application: ${error.response.data.message}`;
      } else if (error.request) {
        errorMessage = 'Failed to send application. Please check your connection or server availability.';
      }
      setSubmissionError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Focus trap for apply modal
  useEffect(() => {
    if (isApplyModalOpen && applyModalRef.current) {
      const focusableElements = applyModalRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        } else if (e.key === 'Escape') {
          closeApplyModal();
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      firstElement.focus();

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [isApplyModalOpen]);

  return (
    <>
      <div className="bg-gradient-to-b from-gray-50 to-white">
        {/* Hero Section */}
        <section className="relative bg-primary-blue text-white py-12 sm:py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative z-10 text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-inter font-bold tracking-tight animate-fade-up">
              Join TGL Credit Limited
            </h1>
            <div className="text-[13px] font-inter font-medium text-gray-100 mt-4 max-w-2xl mx-auto leading-relaxed animate-fade-up" style={{ animationDelay: '0.2s' }}>
              <h2 className="text-lg font-semibold mb-2">How to Apply</h2>
              <p>
                Submit your CV, cover letter, and a brief statement of interest via the application form below. Ensure all documents are in PDF format and under 5MB. For inquiries, contact{' '}
                <a href="mailto:hr@tglcredit.co.ke" className="text-white underline hover:text-primary-red">
                  hr@tglcredit.co.ke
                </a>
              </p>
            </div>
            <button
              onClick={() => openApplyModal('')}
              className="group inline-flex items-center bg-[--primary-blue] text-white font-inter font-medium px-8 py-3 rounded-md hover:bg-[--primary-red] hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 mt-8 text-sm uppercase tracking-wide focus:ring-2 focus:ring-primary-blue focus:ring-offset-2"
              aria-label="Apply for open positions"
            >
              <span className="flex items-center">
                Apply Now
                <span className="ml-2 rounded-full bg-white border border-[--primary-blue] group-hover:border-[--primary-red] p-1 flex items-center justify-center">
                  <IconArrow className="w-3 h-5 group-hover:translate-x-1 transition-transform duration-300 text-[--primary-blue] group-hover:text-[--primary-blue]" />
                </span>
              </span>
            </button>
          </div>
        </section>

        {/* Open Positions Section */}
        <section className="bg-gray-50 py-16 sm:py-24">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-inter font-bold text-primary-blue text-center mb-8 tracking-tight animate-fade-up">
              Open Positions
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mb-8 border-b border-gray-200">
              {['All', 'Finance', 'Customer Service', 'Operations', 'Technology'].map((department) => (
                <button
                  key={department}
                  onClick={() => setFilter(department)}
                  className={`flex items-center px-4 py-2 text-sm font-inter font-medium transition-all duration-300 ${
                    filter === department
                      ? 'bg-primary-blue text-white'
                      : 'text-gray-600 hover:text-primary-red hover:bg-gray-100'
                  } rounded-t-md relative`}
                  aria-selected={filter === department}
                  role="tab"
                  aria-label={`Filter jobs by ${department}`}
                >
                  <TabIcon tab={department} isActive={filter === department} />
                  {department}
                  {filter === department && (
                    <span className="absolute bottom-0 left-0 w-full h-1 bg-primary-red"></span>
                  )}
                </button>
              ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredJobs.length ? (
                filteredJobs.map((job, index) => (
                  <div
                    key={job.id}
                    className="group bg-white/95 backdrop-blur-md p-6 rounded-md shadow-md hover:shadow-lg hover:-translate-y-1 hover:scale-105 transition-all duration-300 border border-primary-blue/10 animate-fade-up"
                    style={{ animationDelay: `${0.4 + index * 0.2}s` }}
                  >
                    <h3 className="text-lg font-inter font-bold text-primary-blue mb-2 tracking-tight">{job.title}</h3>
                    <p className="text-[13px] font-inter font-medium text-gray-600 mb-2">
                      <span className="font-bold">{job.department}</span> | {job.location}
                    </p>
                    <p className="text-[13px] font-inter font-medium text-gray-600 mb-4 leading-relaxed">{job.description}</p>
                    <button
                      onClick={() => openReadMoreModal(job)}
                      className={`group w-full bg-${
                        index % 2 === 0 ? '[--primary-blue]' : '[--primary-red]'
                      } text-white font-inter font-medium px-4 py-2 rounded-md hover:bg-${
                        index % 2 === 0 ? '[--primary-red]' : '[--primary-blue]'
                      } hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 text-sm uppercase tracking-wide focus:ring-2 focus:ring-primary-blue focus:ring-offset-2 flex items-center justify-center`}
                      aria-label={`Read more about ${job.title}`}
                    >
                      <span className="flex items-center">
                        Read More
                        <span className="ml-2 rounded-full bg-white border border-[--primary-blue] group-hover:border-[--primary-red] p-1 flex items-center justify-center">
                          <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-[--primary-blue] group-hover:text-[--primary-blue]" />
                        </span>
                      </span>
                    </button>
                  </div>
                ))
              ) : (
                <div className="col-span-full text-center bg-white/95 backdrop-blur-md p-6 rounded-md shadow-md border border-primary-blue/10 animate-fade-up">
                  <p className="text-lg font-inter font-semibold text-gray-700 leading-relaxed">
                    No positions currently available in the {filter} department.
                  </p>
                  <p className="text-[13px] font-inter font-medium text-gray-600 mt-2">
                    Check back later or contact us for future opportunities.
                  </p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Why TGL Section */}
        <section className="py-16 sm:py-24">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-inter font-bold text-primary-blue text-center mb-12 tracking-tight animate-fade-up">
              Why Work at TGL?
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="group bg-white/95 backdrop-blur-md p-6 rounded-md shadow-md hover:shadow-lg hover:-translate-y-1 hover:scale-105 transition-all duration-300 border border-primary-blue/10 animate-fade-up" style={{ animationDelay: '0.1s' }}>
                <FaBriefcase className="text-primary-red text-3xl mb-4 group-hover:text-primary-red-dark transition-colors duration-300" />
                <h3 className="text-lg font-inter font-bold text-primary-blue mb-2 tracking-tight">Meaningful Work</h3>
                <p className="text-[13px] font-inter font-medium text-gray-600 leading-relaxed">
                  Empower clients with innovative financial solutions that drive growth.
                </p>
              </div>
              <div className="group bg-white/95 backdrop-blur-md p-6 rounded-md shadow-md hover:shadow-lg hover:-translate-y-1 hover:scale-105 transition-all duration-300 border border-primary-blue/10 animate-fade-up" style={{ animationDelay: '0.2s' }}>
                <FaHeartbeat className="text-primary-red text-3xl mb-4 group-hover:text-primary-red-dark transition-colors duration-300" />
                <h3 className="text-lg font-inter font-bold text-primary-blue mb-2 tracking-tight">Comprehensive Benefits</h3>
                <p className="text-[13px] font-inter font-medium text-gray-600 leading-relaxed">
                  Enjoy competitive salaries, health insurance, and retirement plans.
                </p>
              </div>
              <div className="group bg-white/95 backdrop-blur-md p-6 rounded-md shadow-md hover:shadow-lg hover:-translate-y-1 hover:scale-105 transition-all duration-300 border border-primary-blue/10 animate-fade-up" style={{ animationDelay: '0.3s' }}>
                <FaChartLine className="text-primary-red text-3xl mb-4 group-hover:text-primary-red-dark transition-colors duration-300" />
                <h3 className="text-lg font-inter font-bold text-primary-blue mb-2 tracking-tight">Career Growth</h3>
                <p className="text-[13px] font-inter font-medium text-gray-600 leading-relaxed">
                  Access training and mentorship to advance your career.
                </p>
              </div>
              <div className="group bg-white/95 backdrop-blur-md p-6 rounded-md shadow-md hover:shadow-lg hover:-translate-y-1 hover:scale-105 transition-all duration-300 border border-primary-blue/10 animate-fade-up" style={{ animationDelay: '0.4s' }}>
                <FaUsers className="text-primary-red text-3xl mb-4 group-hover:text-primary-red-dark transition-colors duration-300" />
                <h3 className="text-lg font-inter font-bold text-primary-blue mb-2 tracking-tight">Inclusive Culture</h3>
                <p className="text-[13px] font-inter font-medium text-gray-600 leading-relaxed">
                  Thrive in a collaborative, diverse, and supportive environment.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-16 sm:py-24 text-center">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-inter font-bold text-primary-blue mb-6 tracking-tight animate-fade-up">
              Ready to Make a Difference?
            </h2>
            <p className="text-[13px] font-inter font-medium text-gray-600 mb-8 max-w-xl mx-auto leading-relaxed animate-fade-up" style={{ animationDelay: '0.2s' }}>
              Join TGL Credit Limited and shape the future of finance.
            </p>
            <button
              onClick={() => openApplyModal('')}
              className="group inline-flex items-center bg-[--primary-blue] text-white font-inter font-medium px-8 py-3 rounded-md hover:bg-[--primary-red] hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 text-sm uppercase tracking-wide focus:ring-2 focus:ring-primary-blue focus:ring-offset-2"
              aria-label="Apply for open positions"
            >
              <span className="flex items-center">
                Get Started
                <span className="ml-2 rounded-full bg-white border border-[--primary-blue] group-hover:border-[--primary-red] p-1 flex items-center justify-center">
                  <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-[--primary-blue] group-hover:text-[--primary-blue]" />
                </span>
              </span>
            </button>
          </div>
        </section>
      </div>

      {/* Read More Modal */}
      {isReadMoreModalOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-modal-in" role="dialog" aria-modal="true" aria-labelledby="read-more-modal-title">
          <div className="bg-white/95 backdrop-blur-md rounded-lg w-full max-w-4xl mx-4 p-8 shadow-2xl border border-gray-200 overflow-y-auto max-h-[80vh]">
            <div className="flex flex-col">
              <div className="p-6 flex flex-col justify-between">
                <div>
                  <div className="flex justify-between items-center mb-4 sticky top-0 bg-white z-10">
                    <h3 id="read-more-modal-title" className="text-base font-inter font-bold text-primary-blue">{selectedJob.title}</h3>
                    <button
                      onClick={closeReadMoreModal}
                      className="text-primary-blue hover:text-primary-red focus:ring-2 focus:ring-primary-red focus:ring-offset-2 rounded-full p-1"
                      aria-label="Close job details modal"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <hr className="border-primary-red mb-6" />
                  <div className="mb-6">
                    <h4 className="text-sm font-inter font-semibold text-primary-blue mb-2">Details</h4>
                    <ul className="text-xs font-inter font-normal text-gray-600 list-disc pl-5">
                      <li><span className="font-semibold">Employment Type:</span> {selectedJob.details?.employmentType}</li>
                      <li><span className="font-semibold">Experience Level:</span> {selectedJob.details?.experienceLevel}</li>
                      <li><span className="font-semibold">Department:</span> {selectedJob.department}</li>
                      <li><span className="font-semibold">Location:</span> {selectedJob.location}</li>
                    </ul>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-sm font-inter font-semibold text-primary-blue mb-2">Description</h4>
                    <p className="text-xs font-inter font-normal text-gray-600 leading-relaxed">{selectedJob.fullDescription}</p>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-sm font-inter font-semibold text-primary-blue mb-2">Skills Needed</h4>
                    <ul className="text-xs font-inter font-normal text-gray-600 list-disc pl-5">
                      {selectedJob.skillsNeeded?.map((skill, index) => (
                        <li key={index}>{skill}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-sm font-inter font-semibold text-primary-blue mb-2">How to Apply</h4>
                    <p className="text-xs font-inter font-normal text-gray-600 leading-relaxed">{selectedJob.howToApply}</p>
                  </div>
                </div>
                <div className="flex justify-end mt-4">
                  <button
                    onClick={() => {
                      closeReadMoreModal();
                      openApplyModal(selectedJob.title);
                    }}
                    className="group bg-primary-blue text-white font-inter font-medium px-6 py-2 rounded-md hover:bg-primary-red hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-2 flex items-center text-sm uppercase tracking-wide"
                    aria-label={`Apply for ${selectedJob.title}`}
                  >
                    <span className="flex items-center">
                      Apply Now
                      <span className="ml-2 rounded-full bg-white border border-[--primary-blue] group-hover:border-[--primary-red] p-1 flex items-center justify-center">
                        <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-[--primary-blue] group-hover:text-[--primary-blue]" />
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Apply Modal */}
      {isApplyModalOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-end z-50 animate-modal-in" role="dialog" aria-modal="true" aria-labelledby="apply-modal-title">
          <div
            ref={applyModalRef}
            className="bg-white/95 backdrop-blur-md rounded-lg w-full max-w-lg mx-4 p-8 shadow-2xl border border-gray-200"
            style={{ boxShadow: '0 4px 12px rgba(47, 73, 140, 0.3), 0 2px 8px rgba(132, 51, 69, 0.2)' }}
          >
            <div className="flex flex-col">
              <div className="relative mb-6">
                <h3 id="apply-modal-title" className="text-xl font-inter font-bold text-primary-blue tracking-tight text-center">
                  Apply for a Position
                </h3>
                <hr className="mt-2 mb-4 border-t-2 border-primary-blue w-1/2 mx-auto" />
                <button
                  onClick={closeApplyModal}
                  className="absolute top-0 right-0 text-primary-blue hover:text-primary-red focus:ring-2 focus:ring-primary-red focus:ring-offset-2 rounded-full"
                  aria-label="Close application modal"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              {showSuccessMessage ? (
                <div
                  className="bg-green-100 text-green-800 p-4 rounded-lg mb-4 animate-fade-in"
                  role="alert"
                  aria-live="polite"
                >
                  <h4 className="text-base font-inter font-semibold text-green-800">
                    Application Sent Successfully!
                  </h4>
                  <p className="text-sm font-inter text-green-700">
                    Thank you for your application. We’ll respond within 2 hours.
                  </p>
                </div>
              ) : (
                <>
                  {submissionError && (
                    <div
                      className="bg-red-100 text-red-800 p-3 rounded-lg mb-4 animate-fade-in"
                      role="alert"
                      aria-live="polite"
                    >
                      {submissionError}
                    </div>
                  )}
                  {!submissionError && (
                    <p className="text-sm font-inter font-medium text-gray-600 mb-6 text-center">
                      Our team will respond within 2 hours.
                    </p>
                  )}
                  <form onSubmit={handleSubmit} className="space-y-4" noValidate encType="multipart/form-data">
                    <div>
                      <label htmlFor="fullName" className="text-sm font-inter font-semibold text-primary-blue">
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        className={`mt-1 w-full px-4 py-2 text-sm font-inter text-gray-600 border ${
                          formErrors.fullName ? 'border-primary-red' : 'border-primary-blue/30'
                        } rounded-md focus:ring-2 focus:ring-primary-blue focus:outline-none`}
                        placeholder="Enter your full name"
                        required
                        aria-required="true"
                        aria-describedby={formErrors.fullName ? 'fullName-error' : undefined}
                      />
                      {formErrors.fullName && (
                        <p id="fullName-error" className="text-xs text-primary-red mt-1" role="alert">
                          {formErrors.fullName}
                        </p>
                      )}
                    </div>
                    <div>
                      <label htmlFor="email" className="text-sm font-inter font-semibold text-primary-blue">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className={`mt-1 w-full px-4 py-2 text-sm font-inter text-gray-600 border ${
                          formErrors.email ? 'border-primary-red' : 'border-primary-blue/30'
                        } rounded-md focus:ring-2 focus:ring-primary-blue focus:outline-none`}
                        placeholder="Enter your email address"
                        required
                        aria-required="true"
                        aria-describedby={formErrors.email ? 'email-error' : undefined}
                      />
                      {formErrors.email && (
                        <p id="email-error" className="text-xs text-primary-red mt-1" role="alert">
                          {formErrors.email}
                        </p>
                      )}
                    </div>
                    <div>
                      <label htmlFor="position" className="text-sm font-inter font-semibold text-primary-blue">
                        Position Applying For
                      </label>
                      <select
                        id="position"
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                        className={`mt-1 w-full px-4 py-2 text-sm font-inter text-primary-blue bg-gray-50 border ${
                          formErrors.position ? 'border-primary-red' : 'border-primary-blue/30'
                        } rounded-md focus:ring-2 focus:ring-primary-blue focus:outline-none`}
                        required
                        aria-required="true"
                        aria-describedby={formErrors.position ? 'position-error' : undefined}
                      >
                        <option value="" disabled>
                          Select a position
                        </option>
                        {jobListings.map((job) => (
                          <option key={job.id} value={job.title}>
                            {job.title}
                          </option>
                        ))}
                      </select>
                      {formErrors.position && (
                        <p id="position-error" className="text-xs text-primary-red mt-1" role="alert">
                          {formErrors.position}
                        </p>
                      )}
                    </div>
                    <div>
                      <label htmlFor="coverLetter" className="text-sm font-inter font-semibold text-primary-blue">
                        Upload Cover Letter (PDF, max 5MB)
                      </label>
                      <input
                        type="file"
                        id="coverLetter"
                        name="coverLetter"
                        accept="application/pdf"
                        onChange={handleInputChange}
                        className={`mt-1 w-full px-4 py-2 text-sm font-inter text-gray-600 border ${
                          formErrors.coverLetter ? 'border-primary-red' : 'border-primary-blue/30'
                        } rounded-md focus:ring-2 focus:ring-primary-blue focus:outline-none`}
                        required
                        aria-required="true"
                        aria-describedby={formErrors.coverLetter ? 'coverLetter-error' : undefined}
                      />
                      {formErrors.coverLetter && (
                        <p id="coverLetter-error" className="text-xs text-primary-red mt-1" role="alert">
                          {formErrors.coverLetter}
                        </p>
                      )}
                    </div>
                    <div>
                      <label htmlFor="cv" className="text-sm font-inter font-semibold text-primary-blue">
                        Upload CV (PDF, max 5MB)
                      </label>
                      <input
                        type="file"
                        id="cv"
                        name="cv"
                        accept="application/pdf"
                        onChange={handleInputChange}
                        className={`mt-1 w-full px-4 py-2 text-sm font-inter text-gray-600 border ${
                          formErrors.cv ? 'border-primary-red' : 'border-primary-blue/30'
                        } rounded-md focus:ring-2 focus:ring-primary-blue focus:outline-none`}
                        required
                        aria-required="true"
                        aria-describedby={formErrors.cv ? 'cv-error' : undefined}
                      />
                      {formErrors.cv && (
                        <p id="cv-error" className="text-xs text-primary-red mt-1" role="alert">
                          {formErrors.cv}
                        </p>
                      )}
                      <p className="text-xs font-inter text-gray-600 mt-2">
                        Submit your application to{' '}
                        <a href="mailto:hr@tglcredit.co.ke" className="text-primary-blue hover:text-primary-red">
                          hr@tglcredit.co.ke
                        </a>
                      </p>
                    </div>
                    <div className="flex justify-end gap-2 mt-6">
                      <button
                        type="button"
                        onClick={closeApplyModal}
                        className="bg-gray-200 text-primary-blue font-inter font-medium px-4 py-2 rounded-md hover:bg-gray-300 hover:text-primary-red transition-all duration-300 uppercase tracking-wide text-sm focus:ring-2 focus:ring-primary-blue focus:ring-offset-2"
                        disabled={isSubmitting}
                        aria-label="Cancel application"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="group bg-primary-blue text-white font-inter font-medium px-4 py-2 rounded-md hover:bg-primary-red hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 uppercase tracking-wide text-sm focus:ring-2 focus:ring-primary-blue focus:ring-offset-2 flex items-center gap-2"
                        disabled={isSubmitting}
                        aria-label="Submit application"
                      >
                        {isSubmitting ? (
                          <>
                            <svg
                              className="animate-spin h-4 w-4 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Submitting...
                          </>
                        ) : (
                          <>
                            Submit Application
                            <span className="ml-2 rounded-full bg-white border border-[--primary-blue] group-hover:border-[--primary-red] p-1 flex items-center justify-center">
                              <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-[--primary-blue] group-hover:text-[--primary-blue]" />
                            </span>
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.8s ease-in-out forwards;
            will-change: transform, opacity;
          }
          @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .animate-fade-in {
            animation: fade-in 0.8s ease-in-out forwards;
            will-change: opacity;
          }
          @keyframes modal-in {
            from { opacity: 0; transform: translateX(100%) scale(0.95); }
            to { opacity: 1; transform: translateX(0) scale(1); }
          }
          .animate-modal-in {
            animation: modal-in 0.3s ease-out forwards;
            will-change: transform, opacity;
          }
          .backdrop-blur-md {
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
          }
          .backdrop-blur-sm {
            backdrop-filter: blur(4px);
            -webkit-backdrop-filter: blur(4px);
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-fade-up, .animate-fade-in, .animate-modal-in, .hover\\:scale-105, .hover\\:shadow-lg, .group-hover\\:translate-x-1, .group-hover\\:border-primary-red, .hover\\:scale-110 {
              animation: none !important;
              transform: none !important;
              transition: none !important;
            }
          }
          :root {
            --primary-blue: #2F498C;
            --primary-blue-dark: #1e355f;
            --primary-red: #843345;
            --primary-red-dark: #672737;
          }
          .bg-primary-blue {
            background-color: var(--primary-blue);
          }
          .bg-primary-blue-dark {
            background-color: var(--primary-blue-dark);
          }
          .bg-primary-red {
            background-color: var(--primary-red);
          }
          .bg-primary-red-dark {
            background-color: var(--primary-red-dark);
          }
          .text-primary-blue {
            color: var(--primary-blue);
          }
          .text-primary-red {
            color: var(--primary-red);
          }
          .text-primary-red-dark {
            color: var(--primary-red-dark);
          }
          .hover\\:bg-primary-blue:hover {
            background-color: var(--primary-blue);
          }
          .hover\\:bg-primary-blue-dark:hover {
            background-color: var(--primary-blue-dark);
          }
          .hover\\:bg-primary-red:hover {
            background-color: var(--primary-red);
          }
          .hover\\:bg-primary-red-dark:hover {
            background-color: var(--primary-red-dark);
          }
          .hover\\:text-primary-blue:hover {
            color: var(--primary-blue);
          }
          .hover\\:text-primary-red-dark:hover {
            color: var(--primary-red-dark);
          }
          .hover\\:shadow-primary-red\\/30:hover {
            --tw-shadow-color: rgba(132, 51, 69, 0.3);
            --tw-shadow: var(--tw-shadow-colored);
          }
          .focus\\:ring-primary-blue:focus {
            --tw-ring-color: var(--primary-blue);
          }
          .focus\\:ring-primary-red:focus {
            --tw-ring-color: var(--primary-red);
          }
          .border-primary-blue\\/10 {
            border-color: rgba(47, 73, 140, 0.1);
          }
          .border-primary-blue\\/30 {
            border-color: rgba(47, 73, 140, 0.3);
          }
          .group-hover\\:border-primary-red:hover {
            border-color: var(--primary-red);
          }
        `}
      </style>
    </>
  );
}

export default Career;